<template>
    <a v-if="!child"
       class="button-link"
       :href="href"
       @click="$emit('click', $event)"
       @mouseenter="animate = true"
       @mouseleave="animate = false"
    >
        <span class="d-inline-block position-relative">
            <slot></slot>
            <span class="nav__arrow-icon icon-arrow" :class="iconClasses"></span>
        </span>
    </a>
    <button v-else
            class="button-link"
            @click="$emit('click', $event)"
            @mouseenter="animate = true"
            @mouseleave="animate = false"
    >
        <span class="d-inline-block position-relative">
            <span class="text">
                <slot></slot>
            </span>
            <span class="nav__arrow-icon icon-arrow" :class="iconClasses"></span>
        </span>
    </button>
</template>

<script>
    export default {
        props: {
            href: {
                type: String,
                required: true,
            },
            child: {
                type: Object,
            },
        },
        data () {
            return {
                animate: false,
            };
        },
        computed: {
            iconClasses () {
                return {
                    'nav-link-animate': this.animate,
                };
            },
        },
    };
</script>
